import services from '.'
import { IData } from '../@types'
import { INewPackage, IPackage } from '../@types/package'
import { getAxiosErrorMessage } from '../resources'

const baseURL = '/packages'

async function get(): Promise<Array<IPackage> | undefined> {
  try {
    const IPackages = await services.api
      .get<IData<Array<IPackage>>>(baseURL + '')
      .then(({ data }) => data?.data)

    return IPackages
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getBy(id?: string): Promise<IPackage | undefined> {
  if (!id) return
  try {
    const IPackages = await services.api
      .get<IData<Array<IPackage>>>(baseURL + `?id=${id}`)
      .then(({ data }) => data?.data)

    return IPackages && IPackages[0]
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function create(data: INewPackage): Promise<void> {
  try {
    await services.api
      .post<IData<IPackage>>(baseURL + '', data)
      .then(({ data }) => data?.data)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function deleteById(id: string): Promise<void> {
  try {
    await services.api.delete(baseURL, { data: { id } })
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function update(payload: {
  id: string
  name?: string
  price?: string
  description?: string
  resources?: string[]
  expirationDays?: number | null
}): Promise<void> {
  try {
    await services.api.put(baseURL, payload)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function saveLog(id: string): Promise<void> {
  try {
    await services.api.post(`${baseURL}/logs`, { id })
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default {
  get,
  create,
  update,
  deleteById,
  saveLog,
  getBy,
}
